import React, { useRef, useState, useEffect } from 'react'
import styles from './PointsDetail.module.css'
import classNames from 'classnames'
import { Pagination, Space, Table, Tabs } from 'antd'
import { getPointsListRequest } from './api'
import Cookies from 'js-cookie';
export default function PointsDetail(props) {
  const [tabKey, setTabKey] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(100) // 假设数据总条数已知或通过API获取
  const [infoList, setInfoList] = useState([])
  const [userPoints, setUserPoints] = useState(0)
  const [fenpeiJifen, setFenpeiJifen] = useState(0)
  const [chongzhiJifen, setChongzhiJifen] = useState(0)

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    setFenpeiJifen(Cookies.get('fenpei_jifen'))
    setChongzhiJifen(Cookies.get('chongzhi_jifen'))
    getInfoList('', (currentPage - 1) * pageSize, pageSize)
    return () => {
      // console.log('组件即将卸载');
    }
  }, [props.openStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getInfoList(key, offset, limit) {
    getPointsListRequest(key, offset, limit, (data) => {
      console.log(data)
      if (data.ret === '1') {
        setInfoList(data.data.data)
        setTotal(data.data.total_num)
        setUserPoints(data.data.user_jifen)
      } else {
        setInfoList([])
        setTotal(0)
        // setUserPoints(0)
      }
    })
  }

  const columns = [
    {
      title: '明细',
      dataIndex: 'app_name',
      key: 'app_name',
      align: 'center',
      // width: '96px',
      render: (_, record) => (
        <Space size="middle">
          {record.type != 1 ? record.app_name : record.jifen_laiyuan == '1' ? '分配' : '扫码充值'}
        </Space>
      ),
    },

    {
      title: '积分',
      dataIndex: 'jifen',
      key: 'jifen',
      align: 'center',
      render: (_, record) => (
        <Space size="middle">{record.type == 1 ? '+' + _ : '-' + _}</Space>
      ),
    },
    {
      title: '操作时间',
      dataIndex: 'use_time',
      key: 'use_time',
      align: 'center',
      // render: (_, record) => <Space size='middle'>2025-5-1 12:20:12</Space>,
    },
  ]

  const handlePageChange = (page, size) => {
    setCurrentPage(page)
    setPageSize(size)
    getInfoList(tabKey, (page - 1) * size, size)
  }

  return (
    <div
      style={{
        width: 'calc(100% - 160px)',
        marginLeft: 40,
      }}
    >
      <div className={styles.titleDiv}>
        <div className={styles.title0}>积分详情</div>
        {/* <div className={styles.title1}>剩余积分额度：{userPoints}</div> */}
        <div className={styles.title1}>
          剩余积分额度：分配积分剩余 {fenpeiJifen}&nbsp;&nbsp; 充值积分剩余 {chongzhiJifen}
        </div>
      </div>
      <Tabs
        defaultActiveKey=""
        centered
        items={[
          {
            label: '全部',
            key: '',
          },
          {
            label: '消耗',
            key: '2',
          },
          {
            label: '增加',
            key: '1',
          },
        ]}
        onChange={(key) => {
          setInfoList([])
          setTabKey(key)
          setCurrentPage(1)
          setPageSize(10)
          getInfoList(key, 0, 10)
        }}
      />
      <Table
        columns={columns}
        dataSource={infoList}
        // pagination={{
        //     current: currentPage, // 当前页码
        //     pageSize: pageSize, // 每页条数
        //     total: total, // 数据总条数
        //     onChange: handlePageChange, // 分页改变时的回调函数
        //     showSizeChanger: true, // 是否显示每页条数改变的选项
        //     // showQuickJumper: true, // 是否可以快速跳转到指定页
        //     // showTotal: (total) => `共 ${total} 条数据`, // 显示数据总量的函数
        //     hideOnSinglePage:false
        // }}
        pagination={false}
        bordered
        // scroll={{
        //     x: 'max-content',
        //     y: 55 * 5,
        // }}
        tableLayout="auto"
      />
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        showSizeChanger={true}
        hideOnSinglePage={false}
        align="end"
        style={{ marginTop: 20 }}
      />
    </div>
  )
}

